export default __webpack_public_path__ + "static/media/man.826b3b00.svg";